import * as types from "./types";
import database from "../config/database";

export function actionFetchLocations(payload) {
  return {
    type: types.FETCH_LOCATIONS,
    value: payload
  };
}

export function functionFetchLocations() {
  return dispatch => {
    database.ref("/app/locations").once("value", snapshot => {
      const locations = snapshot.val();

      dispatch(
        actionFetchLocations({
          ...locations
        })
      );
    });
  };
}

export function actionSetGeoLocations(payload) {
  return {
    type: types.SET_GEOLOCATIONS,
    value: payload
  };
}

export function functionSetGeoLocations(geo) {
  return dispatch => {
    dispatch(
      actionSetGeoLocations({
        geo
      })
    );
  };
}
